interface GetElementDimensionsProps {
    content: string;
    elementType?: string;
    elementStyles?: Partial<CSSStyleDeclaration>;
}

interface GetElementDimensionsResult {
    width: number;
    height: number;
}

type GetElementDimensions = (props: GetElementDimensionsProps) => GetElementDimensionsResult;

/**
 * Given a string content and element type & optional styles, returns the element's dimensions as they would be rendered
 * in the DOM.
 */
export const getElementDimensions: GetElementDimensions = ({ content, elementType = 'span', elementStyles = {} }) => {
    const element = document.createElement(elementType);

    element.style.visibility = 'hidden';
    element.textContent = content;

    Object.entries(elementStyles).forEach(([key, value]) => {
        element.style[key] = value;
    });

    document.body.appendChild(element);

    const width = element.getBoundingClientRect().width;
    const height = element.getBoundingClientRect().height;

    document.body.removeChild(element);

    return { width, height };
};
